<template>
	<v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript">
				<p class="steps_count">6/8</p>
				평소 1주일간, 한 번에 적어도
                <br />10분 이상씩 걸은 경우를 합하여
                <br />
                <span class="steps_bolder_words">하루 총 30분 이상</span>
                <br />걸은 날은 며칠인가요?
                <br />
                <span class="sub-style2">* 이전 고강도와 중강도 신체 활동 제외</span>
			</v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0 py-4">
			<v-col cols="12" align-self="center" align="center" class="pa-0 ma-0"></v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="center" align="center" class="avatar">
				<img
                    src="@/assets/images/avatar-exercise-03.png"
                    class="avatar-img"
                    alt="아바타"
                />
			</v-col>
			<v-col cols="12" align-self="center" align="center" class="px-0 mx-0">
				<slide-picker
                    ref="picker"
                    :items="dayItems"
                    :initial-index="0"
                    :tab-index="1"
                    @value="onValue"
                />
			</v-col>
		</v-row>

        <v-container class="pa-0 ma-0 mt-11 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
    </v-container>
</template>

<script>
	import { mapActions, mapGetters } from "vuex";
	import SlidePicker from '../../components/SlidePicker';
	export default {
		data: () => ({
			enableButton: true,
			wlk30WekFreq: 0,
			slideIndex: 0,
			dayItems: ['없음', '하루', '이틀', '사흘', '나흘', '닷새', '엿새', '이레'],
			slides: [
				{ title: "없음" },
				{ title: "하루" },
				{ title: "이틀" },
				{ title: "사흘" },
				{ title: "나흘" },
				{ title: "닷새" },
				{ title: "엿새" },
				{ title: "이레" }
			]
		}),

		methods: {
			...mapActions("survey", ["setCheckupTemp", "setStep"]),
			onValue ({ index }) {
				this.wlk30WekFreq = index
			},
			previous() {
				this.setStep(8)
				this.$router.push("/checkup/step8")
			},
			next() {
				const params = {
					step: 9,
					wlk30WekFreq: this.wlk30WekFreq
				};
				this.setCheckupTemp(params);
				this.setStep(10)
				this.$router.push("/checkup/step10");
			},
			setSliderValue(index) {
				this.slideIndex = index;
			},
			async restoreData() {
                await this.$nextTick()
				if (this.checkUp.wlk30WekFreq > 0) {
					this.wlk30WekFreq = this.checkUp.wlk30WekFreq;
					this.slideIndex = this.checkUp.wlk30WekFreq;
					this.$refs.picker.setPosition(this.slideIndex)
				}
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			this.setStep(9)
			this.restoreData()
		},
		computed: {
			...mapGetters("survey", {
				checkUp: "checkUp"
			})
		},
		components: {
			SlidePicker,
		}
	};
</script>

<style scoped>
	.sub-style2 {
		font-family: "NanumSquare", sans-serif;
		font-weight: 700;

		font-size: 14px;
		letter-spacing: -0.35px;
		color: #202020;
		opacity: 0.5;
	}
    .title {
        min-height: 30vh;
    }
	.avatar-img {
		height: 19vh;
	}

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }

</style>
